import React from 'react';
import { FormInputUnit } from "../../../formInputUnit/FormInputUnit.js";
import { FormLayout } from "../../../formLayout/FormLayout.js";
import { InfoTooltip } from "../../../infoTooltip/InfoTooltip.js";
import { Skeleton } from "../../../skeleton/Skeleton.js";
import { useFormContext } from "../../context/FormContext/index.js";
import { useCustomRule } from "../../hooks/useCustomRule.js";
import { useDefaultValueValidation } from "../../hooks/useDefaultValueValidation.js";
import { ConditionalWrapper } from "../ConditionalWrapper/ConditionalWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
export function CustomFormInputUnit({
  element,
  control,
  useSmallFields,
  isFormDisabled,
  isLoading,
  showCheckmark
}) {
  useCustomRule(element.customRuleFn);
  const formContext = useFormContext();
  useDefaultValueValidation(formContext, element.id);
  const inputUnitProps = {
    ...element.componentProps,
    small: useSmallFields,
    disabled: isFormDisabled,
    format: {
      ...element.componentProps.format,
      onValueChange: values => element.componentProps.format?.onValueChange?.(values, formContext)
    }
  };
  return /*#__PURE__*/_jsx(FormLayout, {
    spacing: !element.tooltip,
    children: /*#__PURE__*/_jsx(ConditionalWrapper, {
      condition: !!element.tooltip && !isLoading,
      wrapper: children => /*#__PURE__*/_jsx(InfoTooltip, {
        title: element.tooltip?.title,
        content: element.tooltip?.content,
        children: children
      }),
      children: /*#__PURE__*/_jsx(Skeleton, {
        loading: isLoading,
        minHeight: "49px",
        children: /*#__PURE__*/_jsx(FormInputUnit, {
          control: control,
          name: element.id,
          rules: element.setRules?.(formContext),
          defaultValue: element.componentProps.value,
          inputUnitProps: inputUnitProps,
          showCheckmark: showCheckmark
        })
      })
    })
  });
}